__turbopack_context__.v({
  "resultCount": "ResultCount-module__ptNmcG__resultCount",
});
